document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict(), 
			partners,
			partners_single_conference,
			top_news, 
			user_news, 
			latest_news, 
			latest_podcasts, 
			latest_podcasts_single, 
			stories, 
			sponsor_logo_sliders, 
			latest_news_single, 
			latest_news_single_bottom,
			latest_events_home_in_events, 
			sidebar_gallery, 
			home_podcasts_swiper_slider, 
			top_news_industry_events,
			top_news_card__publications_all,
			product_publication_single;
    /**
	 * Swiperjs codes
	 */
	partners = new Swiper('.partners-slider', {
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		slidesPerView: 5,
		spaceBetween: 40,
		autoplay: true,
		loop: false,
		speed: 1000,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			768: {
				slidesPerView: 2
			},
			992: {
				slidesPerView: 3
			},
			1200: {
				slidesPerView: 5
			}
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-nav-wrap_partners .swiper-button-next',
			prevEl: '.swiper-nav-wrap_partners .swiper-button-prev',
		},
		pagination: {
			el: '.swiper-nav-wrap_partners .swiper-pagination',
			type: "fraction",
			clickable: true,
		},
		grabCursor: true
	});

	partners_single_conference = new Swiper('.single-conference .section__partners.conferences-footer-partners .partners-slider', {
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		slidesPerView: 4,
		spaceBetween: 40,
		autoplay: true,
		loop: false,
		speed: 1000,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			768: {
				slidesPerView: 2
			},
			992: {
				slidesPerView: 3
			},
			1200: {
				slidesPerView: 4
			}
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-nav-wrap_partners .swiper-button-next',
			prevEl: '.swiper-nav-wrap_partners .swiper-button-prev',
		},
		pagination: {
			el: '.swiper-nav-wrap_partners .swiper-pagination',
			type: "fraction",
			clickable: true,
		},
		grabCursor: true
	});

	top_news = new Swiper('.featured-top-news-swiper-slider', {
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		slidesPerView: 1,
		spaceBetween: 0,
		// autoHeight: true,
		loop: true,
		speed: 1000,
		autoplay: false,
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: "fraction",
			clickable: true,
		  },
		grabCursor: true
	});

	user_news = new Swiper('.user-news-swiper-slider', {
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		slidesPerView: 4,
		spaceBetween: 0,
		autoHeight: true,
		loop: true,
		speed: 1000,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			992: {
				slidesPerView: 3
			},
			1440: {
				slidesPerView: 4
			}
		},
		autoplay: false,
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next__usr',
			prevEl: '.swiper-button-prev__usr',
		},
		pagination: {
			el: '.swiper-pagination__usr',
			type: "fraction",
			clickable: true,
		  },
		grabCursor: true
	});

	latest_news = new Swiper('.latest-news-swiper-slider', {
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		slidesPerView: 3,
		spaceBetween: 0,
		autoHeight: true,
		loop: true,
		speed: 1000,
		autoplay: false,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			992: {
				slidesPerView: 2
			}
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next__last',
			prevEl: '.swiper-button-prev__last',
		},
		pagination: {
			el: '.swiper-pagination__last',
			type: "fraction",
			formatFractionCurrent: function(number) { return number + 3; },
			formatFractionTotal: function(number) { return number + 3; },
			clickable: true,
		  },
		grabCursor: true
	});

	latest_podcasts = new Swiper('.latest-podcasts-swiper-slider', {
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		slidesPerView: 6,
		spaceBetween: 20,
		autoHeight: false,
		loop: true,
		speed: 1000,
		autoplay: false,
		breakpoints: {
			320: {
				slidesPerView: 2,
				spaceBetween: 5,
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 4,
			},
			1400: {
				slidesPerView: 6
			},
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next__latest-podcasts',
			prevEl: '.swiper-button-prev__latest-podcasts',
		},
		pagination: {
			el: '.swiper-pagination__latest-podcasts',
			type: "fraction",
			clickable: true,
		  },
		grabCursor: true
	});

	latest_podcasts_single = new Swiper('.latest-podcasts-swiper-slider_single', {
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		slidesPerView: 3,
		spaceBetween: 20,
		autoHeight: false,
		loop: true,
		speed: 1000,
		autoplay: false,
		breakpoints: {
			320: {
				slidesPerView: 2
			},
			768: {
				slidesPerView: 2
			},
			1712: {
				slidesPerView: 3
			},
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next__latest-podcasts_single',
			prevEl: '.swiper-button-prev__latest-podcasts_single',
		},
		pagination: {
			el: '.swiper-pagination__latest-podcasts_single',
			type: "fraction",
			clickable: true,
		  },
		grabCursor: true
	});

	latest_news_single = new Swiper('.latest-news-swiper-slider_single', {
        observer: true,
        observeParents: true,
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		slidesPerGroup: 4,
		slidesPerView: 4,
		spaceBetween: 5,
		autoHeight: false,
		freeMode: false,
		loop: true,
		speed: 1000,
		autoplay: false,
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next__latest-news_single',
			prevEl: '.swiper-button-prev__latest-news_single',
		},
		pagination: {
			el: '.swiper-pagination__latest-news_single',
			type: "fraction",
			clickable: true,
		  },
		grabCursor: false
	});

	product_publication_single = new Swiper('.single-product-publication .content-sidebar .looping-content', {
        observer: true,
        observeParents: true,
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		// slidesPerGroup: 4,
		// slidesPerView: 4,
		spaceBetween: 30,
		autoHeight: false,
		direction: 'horizontal',
		freeMode: false,
		loop: true,
		speed: 1000,
		autoplay: false,
		breakpoints: {
			320: {
				slidesPerGroup: 1,
				slidesPerView: 1,
			},
			768: {
				slidesPerGroup: 1,
				slidesPerView: 1,
			},
			1024: {
				slidesPerGroup: 4,
				slidesPerView: 4,
			},
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next__latest-news_single',
			prevEl: '.swiper-button-prev__latest-news_single',
		},
		pagination: {
			el: '.swiper-pagination__latest-news_single',
			type: "fraction",
			clickable: true,
		  },
		grabCursor: false
	});

	document.querySelectorAll('.card__publications--content.magazine').forEach(function(container) {
		let uniqueId = container.getAttribute('data-id');
		new Swiper(container, {
			observer: true,
			observeParents: true,
			observeSlideChildren: false,
			slideToClickedSlide: false,
			updateOnWindowResize: true,
			spaceBetween: 30,
			autoHeight: false,
			direction: 'horizontal',
			freeMode: false,
			loop: true,
			speed: 1000,
			autoplay: false,
			breakpoints: {
				320: {
					slidesPerGroup: 1,
					slidesPerView: 1,
				},
				768: {
					slidesPerGroup: 2,
					slidesPerView: 2,
				},
				1024: {
					slidesPerGroup: 3,
					slidesPerView: 3,
				},
				1440: {
					slidesPerGroup: 4,
					slidesPerView: 4,
				},
				1640: {
					slidesPerGroup: 6,
					slidesPerView: 6,
				},
			},
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			navigation: {
				nextEl: `.swiper-button-next__${uniqueId}`,
				prevEl: `.swiper-button-prev__${uniqueId}`,
			},
			pagination: {
				el: `.swiper-pagination__${uniqueId}`,
				type: "fraction",
				clickable: true,
			},
			grabCursor: false
		});
	});	

	//latest-news-swiper-slider-single-bottom
	latest_news_single_bottom = new Swiper('.latest-news-swiper-slider-single-bottom', {
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		slidesPerView: 4,
		spaceBetween: 0,
		autoHeight: false,
		loop: false,
		speed: 1000,
		autoplay: false,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			768: {
				slidesPerView: 2
			},
			1440: {
				slidesPerView: 3
			},
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next__latest-news-single-bottom',
			prevEl: '.swiper-button-prev__latest-news-single-bottom',
		},
		pagination: {
			el: '.swiper-pagination__latest-news-single-bottom',
			type: "fraction",
			clickable: true,
		  },
		grabCursor: true
	});

	stories = new Swiper('.stories-news-swiper-slider', {
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		slidesPerView: 3,
		spaceBetween: 20,
		autoHeight: true,
		loop: true,
		speed: 1000,
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 0
			},
			992: {
				slidesPerView: 2
			},
			1440: {
				slidesPerView: 3
			}
		},
		autoplay: false,
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next__stories',
			prevEl: '.swiper-button-prev__stories',
		},
		pagination: {
			el: '.swiper-pagination__stories',
			type: "fraction",
			formatFractionCurrent: function(number) { return number + 3; },
			formatFractionTotal: function(number) { return number + 3; },
			clickable: true,
		},
		grabCursor: true
	});

	home_podcasts_swiper_slider = new Swiper('.featured-home-podcasts-swiper-slider', {
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		slidesPerView: 3,
		spaceBetween: 0,
		autoHeight: false,
		loop: false,
		speed: 1000,
		autoplay: false,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			760: {
				slidesPerView: 2
			},
			1441: {
				slidesPerView: 3
			}
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next__featured-home-podcasts',
			prevEl: '.swiper-button-prev__featured-home-podcasts',
		},
		pagination: {
			el: '.swiper-pagination__featured-home-podcasts',
			type: "fraction",
			clickable: true,
		  },
		grabCursor: true
	});
	
	// sidebar_gallery = new Swiper('.sidebar-gallery-slider', {
	// 	observeSlideChildren: false,
	// 	slideToClickedSlide: false,
	// 	updateOnWindowResize: true,
	// 	slidesPerView: 1,
	// 	autoHeight: true,
	// 	loop: true,
	// 	speed: 1000,
	// 	autoplay: false,
	// 	keyboard: {
	// 		enabled: true,
	// 		onlyInViewport: false,
	// 	},
	// 	navigation: {
	// 		nextEl: '.swiper-button-next',
	// 		prevEl: '.swiper-button-prev',
	// 	},
	// 	pagination: {
	// 		el: '.swiper-pagination',
	// 		type: "fraction",
	// 		clickable: true,
	// 	},
	// 	grabCursor: true
	// });
	
	sponsor_logo_sliders = new Swiper('.sponsor-logo-slider', {
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		slidesPerView: 1,
		spaceBetween: 0,
		autoHeight: true,
		loop: false,
		speed: 1000,
		autoplay: false,
		breakpoints: {
			768: {
				slidesPerView: 4,
				spaceBetween: 25,
			}
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: "fraction",
			clickable: true,
		},
		grabCursor: true
	});

	top_news_industry_events = new Swiper('.featured-top-news-swiper-slider.industry-event', {
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		slidesPerView: 1,
		spaceBetween: 30,
		autoHeight: true,
		loop: true,
		speed: 1000,
		autoplay: false,
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: "fraction",
			clickable: true,
		  },
		grabCursor: true
	});
	
	//section__events-home--right
	latest_events_home_in_events = new Swiper('.section__events-home--right .swiper', {
		observeSlideChildren: false,
		slideToClickedSlide: false,
		updateOnWindowResize: true,
		slidesPerGroup: 1,
		slidesPerView: 2,
		spaceBetween: 20,
		autoHeight: true,
		loop: false,
		direction: "vertical",
		speed: 1000,
		autoplay: false,
		breakpoints: {
			320: {
				slidesPerGroup: 1,
				slidesPerView: 1
			},
			768: {
				slidesPerGroup: 1,
				slidesPerView: 1
			},
			992: {
				slidesPerGroup: 1,
				slidesPerView: 2
			}
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next__featured-home-in-events',
			prevEl: '.swiper-button-prev__featured-home-in-events',
		},
		pagination: {
			el: '.swiper-pagination__featured-home-in-events',
			type: "fraction",
			clickable: true
		  },
		grabCursor: true
	});	
});

let swiperInstances = {};

function destroyExistingSwipers() {
    Object.values(swiperInstances).forEach(swiper => {
        if (swiper && typeof swiper.destroy === 'function') {
            swiper.destroy(true, true);
        }
    });
    swiperInstances = {};
}

function publicationsAllMobile() {
    if (!window.matchMedia('(max-width: 1024px)').matches) {
        destroyExistingSwipers();
        return;
    }

    const containers = jQuery(".gridlove-site-content.card__publications .card__publications--content");
    
    containers.each(function(index) {
        var uniqueId = 'swiper-' + index;
        var slidesCount = jQuery(this).find('.row .col-lg-3.col-md-12').length;
        
        // Si no hay slides, no inicializar Swiper
        if (slidesCount === 0) {
            console.log(`Skipping Swiper ${uniqueId} - No slides found`);
            return;
        }

        // Destruir instancia previa si existe
        if (swiperInstances[uniqueId]) {
            swiperInstances[uniqueId].destroy(true, true);
        }

        jQuery(this).addClass('swiper').attr('id', uniqueId);
        jQuery(this).find('.row').addClass('swiper-wrapper');
        jQuery(this).find('.row .col-lg-3.col-md-12').addClass('swiper-slide');

        jQuery(this).append(`
            <div class="swiper-nav-wrap publications">
                <div class="swiper-button-prev swiper-button-prev-${uniqueId}"></div>
                <div class="swiper-pagination swiper-pagination-${uniqueId}"></div>
                <div class="swiper-button-next swiper-button-next-${uniqueId}"></div>
            </div>
        `);

        try {
            swiperInstances[uniqueId] = new Swiper('#' + uniqueId, {
                observeSlideChildren: false,
                slideToClickedSlide: false,
                updateOnWindowResize: true,
                slidesPerView: 1,
                spaceBetween: 30,
                autoHeight: true,
                loop: slidesCount > 3,
                speed: 1000,
                autoplay: false,
                breakpoints: {
                    520: {
                        slidesPerView: Math.min(1, slidesCount),
                        loop: slidesCount > 1
                    },
                    760: {
                        slidesPerView: Math.min(2, slidesCount),
                        loop: slidesCount > 2
                    },
                    992: {
                        slidesPerView: Math.min(3, slidesCount),
                        loop: slidesCount > 3
                    }
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: false,
                },
                navigation: {
                    nextEl: `.swiper-button-next-${uniqueId}`,
                    prevEl: `.swiper-button-prev-${uniqueId}`,
                },
                pagination: {
                    el: `.swiper-pagination-${uniqueId}`,
                    type: "fraction",
                    clickable: true,
                },
                grabCursor: true
            });
        } catch (error) {
            console.error(`Error initializing Swiper ${uniqueId}:`, error);
        }
    });
}

// Run on page load
document.addEventListener('DOMContentLoaded', publicationsAllMobile);

// Run on window resize
window.addEventListener('resize', publicationsAllMobile);

// Run on page load
jQuery(document).ready(publicationsAllMobile);



function publicationsHomeMobile() {
	if (window.matchMedia('(max-width: 520px)').matches) {

		var component = jQuery('.card__publications--content.home');

		component.addClass('swiper');

		component.find('.row').addClass('swiper-wrapper');
		component.find('.row .col-xl-3.col-lg-4.col-md-6.col-sm-12').addClass('swiper-slide');

		// Add custom navigation for each swiper
		component.append(`
			<div class="swiper-nav-wrap publications home">
				<div class="swiper-button-prev swiper-button-prev"></div>
				<div class="swiper-pagination swiper-pagination"></div>
				<div class="swiper-button-next swiper-button-next"></div>
			</div>
		`);

		// Initialize a Swiper instance for each container
		new Swiper(component.get(0), {
			observeSlideChildren: false,
			slideToClickedSlide: false,
			updateOnWindowResize: true,
			slidesPerView: 1,
			spaceBetween: 30,
			autoHeight: true,
			loop: true,
			speed: 1000,
			autoplay: false,
			breakpoints: {
				520: {
					slidesPerView: 1
				},
				760: {
					slidesPerView: 2
				},
				992: {
					slidesPerView: 3
				}
			},
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			navigation: {
				nextEl: `.swiper-button-next`,
				prevEl: `.swiper-button-prev`,
			},
			pagination: {
				el: `.swiper-pagination`,
				type: "fraction",
				clickable: true,
			},
			grabCursor: true
		});
	}
}

// Run on page load
document.addEventListener('DOMContentLoaded', publicationsHomeMobile);

// Run on window resize
window.addEventListener('resize', publicationsHomeMobile);

// Run on page load
jQuery(document).ready(publicationsHomeMobile);
